/*@flow*/
import React from 'react';
import cx from 'classnames';
import type { TemplateProps } from 'types/tcomb';

const Template = (props: TemplateProps) => (
  <div className={cx('form-group', { 'has-error': props.hasError })}>
    <label className="col-form-label">{props.label}</label>
    <textarea
      spellCheck={false}
      style={{
        display: 'block',
        border: 'none',
        width: '100%',
        color: 'red',
        borderLeft: 'solid 3px #efefef',
        paddingLeft: 10,
        paddingTop: 0,
        minHeight: 100,
      }}
      value={props.value}
      onChange={(e) => props.onChange(e.target.value)}
    />
    {props.help && <span className="form-text text-muted">{props.help}</span>}
  </div>
);

type Config = React$ComponentType<TemplateProps>;

export default (React.createFactory<Config>(Template): React$ElementFactory<Config>);
